import { gql } from '@apollo/client';

export const CREATE_HIERARCHY_COMPANY_MUTATION = gql`
  mutation SalesWebCreateCompany($input: CreateCompanyInput) {
    createCompany(input: $input) {
      id
      name
      legalName
      docType
      docNumber
      clientId
    }
  }
`;
